import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Modal,
	Form,
	Input,
	Row,
	Col,
	Select,
	InputNumber,
} from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
const { Title } = Typography;

const optionsFractureType = [
	{ value: "Type 1", label: "Type 1" },
	{ value: "Type 2", label: "Type 2" },
	{ value: "Type 3", label: "Type 3" },
	{ value: "Type 4", label: "Type 4" },
	{ value: "Type 5", label: "Type 5" },
	{ value: "Type 6", label: "Type 6" },
];

const QAQCTestingLoadModal = ({
	modalOpenTestingLoad,
	setModalOpenTestingLoad,
	selectedLoad,
	setSelectedLoad,
	setRefresh,
}) => {
	const [loading, setLoading] = useState(true);
	const [loadingForm, setLoadingForm] = useState(false);
	const [form] = Form.useForm();
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		if (selectedLoad) getLoadData();
	}, [selectedLoad]);

	const getLoadData = async () => {
		try {
			setLoading(true);
			const url = api + `/job/get/qc/load/${selectedLoad.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let testingMaxLoad = [];

				if (data.payload.qcData.testingMaxLoad.length !== 0) {
					form.setFieldsValue({
						testingMaxLoad: [
							...data.payload.qcData.testingMaxLoad.map((item) => ({
								...item,
								disabled:
									item.maxLoad !== undefined &&
									item.fractureType !== undefined &&
									item.fractureType !== undefined &&
									item.fractureType !== undefined
										? true
										: false,
							})),
						],
					});
				} else {
					data.payload.qcData.specimensIDS.map((id) => {
						testingMaxLoad.push({
							specimenId: id,
							maxLoad: undefined,
							fractureType: undefined,
							disabled: false,
						});
					});
					form.setFieldsValue({ testingMaxLoad });
				}
				setLoading(false);
			} else {
				setLoading(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const onFinish = async () => {
		const values = form.getFieldsValue(true);

		try {
			setLoadingForm(true);
			const url = api + `/job/update/qc/load/testingload/${selectedLoad.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, values);
			if (data.success) {
				openNotification("success", "Updated", data.message);
				setTimeout(() => {
					form.resetFields();
					setLoadingForm(false);
					setSelectedLoad(undefined);
					setModalOpenTestingLoad(false);
					setRefresh((prev) => !prev);
				}, 2000);
			} else {
				setLoadingForm(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderForm = () => {
		return (
			<Form form={form} onFinish={onFinish} layout="vertical">
				<Form.List name="testingMaxLoad">
					{(fields) => (
						<>
							{fields.map(({ key, name, ...restField }) => {
								const isDisabled = form.getFieldValue([
									"testingMaxLoad",
									name,
									"disabled",
								]);
								return (
									<Row gutter={16} key={key}>
										<Col span={8}>
											<Form.Item
												{...restField}
												label="Specimen ID"
												name={[name, "specimenId"]}
												rules={[
													{ required: true, message: "Missing Specimen ID" },
												]}
											>
												<Input size="large" disabled />
											</Form.Item>
										</Col>
										<Col span={8}>
											<Form.Item
												{...restField}
												label="Max Load [lbs]"
												name={[name, "maxLoad"]}
											>
												<InputNumber
													size="large"
													style={{ width: "100%" }}
													disabled={isDisabled}
												/>
											</Form.Item>
										</Col>
										<Col span={8}>
											<Form.Item
												{...restField}
												label="Fracture Type"
												name={[name, "fractureType"]}
											>
												<Select
													size="large"
													options={optionsFractureType}
													disabled={isDisabled}
													allowClear
												/>
											</Form.Item>
										</Col>
									</Row>
								);
							})}
						</>
					)}
				</Form.List>
				<Form.Item>
					<Button
						type="primary"
						size="large"
						htmlType="submit"
						loading={loadingForm}
					>
						Submit
					</Button>
				</Form.Item>
			</Form>
		);
	};

	return (
		<Modal
			title={`Load ID: ${selectedLoad?.deliveryTicket}`}
			open={modalOpenTestingLoad}
			onCancel={() => {
				form.resetFields();
				setSelectedLoad(undefined);
				setModalOpenTestingLoad(false);
			}}
			footer={null}
			width={800}
			centered
		>
			<Flex vertical gap={16}>
				<Title level={4}>Add Testing Load</Title>
				{loading ? <CustomSpinner /> : <RenderForm />}
			</Flex>
			{contextHolder}
		</Modal>
	);
};

export default QAQCTestingLoadModal;
